/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { WhatsAppIntegration } from '../models/WhatsAppIntegration';
import type { WhatsAppIntegrationCreateBodyParams } from '../models/WhatsAppIntegrationCreateBodyParams';
import type { WhatsAppIntegrationDeleteResponse } from '../models/WhatsAppIntegrationDeleteResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MessagingWhatsappIntegrationsService {
    /**
     * @returns WhatsAppIntegration Ok
     * @throws ApiError
     */
    public static listIntegrations(): CancelablePromise<Array<WhatsAppIntegration>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/messaging/whatsapp/integrations',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden.`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns WhatsAppIntegration Ok
     * @throws ApiError
     */
    public static createIntegration(
        requestBody: WhatsAppIntegrationCreateBodyParams,
    ): CancelablePromise<WhatsAppIntegration> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/messaging/whatsapp/integrations',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden.`,
            },
        });
    }
    /**
     * @param integrationProviderId
     * @returns WhatsAppIntegrationDeleteResponse Ok
     * @throws ApiError
     */
    public static deleteIntegration(
        integrationProviderId: string,
    ): CancelablePromise<WhatsAppIntegrationDeleteResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/messaging/whatsapp/integrations/{integrationProviderId}',
            path: {
                'integrationProviderId': integrationProviderId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden.`,
            },
        });
    }
}
